import React from 'react';
import { Navigate } from 'react-router-dom';
import SEO from '../components/common/SEO';
import LoginForm from '../components/LoginForm';
import { useAuth } from '../contexts/AuthContext';

const LoginPage: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading spinner while checking authentication status
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Redirect to home if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="login-page">
      <SEO 
        title="Login | Quicket"
        description="Sign in to your Quicket account to access your tickets, events, and more."
      />
      <LoginForm />
    </div>
  );
};

export default LoginPage;
